/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, styled, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

export default function FilterPanel({
    applyFilter
}) {
    const [expanded, setExpanded] = useState(false);
    const [filters, setFilters] = useState(localStorage.getItem('levelfilters') ? JSON.parse(localStorage.getItem('levelfilters')) : {});

    const handleChange = (panel) => (event, isExpanded) => {
        if (panel === 'panel1' && isExpanded) {
            const obj = filters;
            if (!obj?.isDeleted) {
                obj.isDeleted = null;
            }
            setFilters(obj);
        }
        setExpanded(isExpanded ? panel : false);
    };

    const handleFilter = async () => {
        setExpanded(false);
        await applyFilter(filters);
    }

    return (
        <CustomFilterPanelWrapper>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Filters</Typography>
            <FilterContent>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.isDeleted === 'yes' || filters?.isDeleted === 'no') && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">InActive Level</Typography>
                            </Box>
                            {expanded === 'panel1' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.isDeleted;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.isDeleted === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.isDeleted === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </FilterContent>
            <FilterFooter>
                <FixedButton variant="outlined" color="secondary" onClick={() => {
                    applyFilter({});
                    setFilters({});
                    setExpanded(false);
                    localStorage.removeItem('levelfilters');
                }}>Clear</FixedButton>
                <FixedButton variant="outlined" color="primary" onClick={() => handleFilter()}>Apply</FixedButton>
            </FilterFooter>
        </CustomFilterPanelWrapper>
    )
}